import { create } from "zustand";

interface DeviceState {
  isMobile: boolean;
  setIsMobile: (value: boolean) => void;
}

export const useDevice = create<DeviceState>((set) => ({
  isMobile: false,
  setIsMobile: (value) => set({ isMobile: value }),
}));

if (window && window.matchMedia) {
  const mediaQuery = window.matchMedia("(max-width: 768px)");

  useDevice.getState().setIsMobile(mediaQuery.matches);

  const handleChange = (event: MediaQueryListEvent) => {
    useDevice.getState().setIsMobile(event.matches);
  };

  mediaQuery.addEventListener("change", handleChange);
}
